export default "__VITE_ASSET__CFToETyV__"